import React from 'react'
import { useNavigate } from 'react-router-dom'
import { faEye, faPen } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcFlexBox,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  PixelTag,
  PixelTooltip,
  Section,
  SectionContent,
} from 'pixel-base'

import {
  getBusinessTypes,
  getContractTypes,
  getVendors,
} from 'utils/api-routes.util'

import UpdateVendors from './component/UpdateVendors'

const breadcrumbs = [
  {
    name: 'Vendors',
    active: false,
  },
  {
    name: 'All Vendors',
    active: true,
  },
]

const VendorsList = () => {
  const navigate = useNavigate()

  const [contract, setContract] = React.useState([])
  const [vendors, setVendors] = React.useState<any>([])
  const [tableLoading, setTableLoader] = React.useState(true)
  const [updateVendors, setUpdateVendors] = React.useState(false)
  const [selectedVendor, setSelectVendor] = React.useState()
  const [businessType, setBusinessType] = React.useState()
  React.useEffect(() => {
    getAllVendors()
    getAllContractTerms()
    getAllBusinessTypes()
  }, [])
  const getAllContractTerms = () => {
    getContractTypes().subscribe((res: any) => {
      setContract(res.response.data)
    })
  }
  const getAllBusinessTypes = () => {
    getBusinessTypes().subscribe((res: any) => {
      setBusinessType(res.response.data)
    })
  }
  const getAllVendors = () => {
    setTableLoader(true)
    getVendors().subscribe((res: any) => {
      setVendors(res.response.data)
      setTableLoader(false)
    })
  }
  const columns = [
    {
      dataKey: 'name',
      name: 'Vendor Name',
      sortable: true,
      selector: (row) => row.name || '--',
    },
    {
      dataKey: 'business_type_name',
      name: 'Vendor Type',
      sortable: true,
      selector: (row) =>
        row.business_type_name === 'vendor' ? (
          <PixelTag className="success">{row.business_type_name}</PixelTag>
        ) : (
          <PixelTag className="info">{row.business_type_name}</PixelTag> || '--'
        ),
    },
    {
      dataKey: 'contact_person',
      name: 'Contact Person',
      sortable: true,
      selector: (row) => row.contact_person || '--',
    },
    {
      dataKey: 'phone',
      name: 'Phone',
      sortable: true,
      selector: (row) => row.phone || '--',
    },
    {
      dataKey: 'term_name',
      name: 'Contract',
      sortable: true,
      selector: (row) =>
        (row.term_name && (
          <PixelTooltip tooltipText={row.contract_details}>
            <PixelTag className="info">{row.term_name}</PixelTag>
          </PixelTooltip>
        )) || <PixelTag className="info">No Contract</PixelTag>,
    },
    {
      dataKey: 'business_contract_start_date',
      name: 'Contract Start Date',
      sortable: true,
      selector: (row) => row.business_contract_start_date || '--',
    },

    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]
  const actions = [
    {
      title: 'Edit',
      icon: (
        <Section>
          <PixelIcon color={$DCprimaryColor} icon={faPen} />
        </Section>
      ),
      clickHandler: (row) => {
        setUpdateVendors(true)
        setSelectVendor(row)
      },
    },
    {
      title: 'View Orders',
      icon: (
        <Section>
          <PixelIcon color={$DCprimaryColor} icon={faEye} />
        </Section>
      ),
      clickHandler: (row) => {
        navigate(`/orders?vendor_id=${row.id}&status=all`)
      },
    },
  ]

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{ fontSize: '16px', padding: '8px 0px' }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>
      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={vendors}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {updateVendors && (
        <PixelModal
          size={'lg'}
          title={'Update Vendor'}
          handleClose={() => setUpdateVendors(false)}
          show={updateVendors}
        >
          {updateVendors && selectedVendor && (
            <UpdateVendors
              selectedVendor={selectedVendor}
              contract={contract}
              businessType={businessType}
              handleClose={(data) => {
                setUpdateVendors(false)
                setVendors(
                  vendors.map((v) => {
                    if (v.id === data.id) return { ...v, ...data }
                    return v
                  }),
                )
              }}
            />
          )}
        </PixelModal>
      )}
    </>
  )
}

export default VendorsList
